import { useTranslation } from 'react-i18next';

import type { MetagameFeatureConfig } from './metagameFeatureBalance';
import { formatFeatureBalance } from './metagameFeatureBalance';
import styles from './MetagameFeaturePill.module.scss';

interface MetagameFeaturePillProps {
  balance: number;
  labelKey: MetagameFeatureConfig['labelKey'];
  colors: MetagameFeatureConfig['colors'][keyof MetagameFeatureConfig['colors']];
}

export function MetagameFeaturePill({ balance, labelKey, colors }: MetagameFeaturePillProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.pill} data-testid="metagame-feature-pill" style={colors}>
      <span className={styles.count}>{formatFeatureBalance(balance)}</span> {t(labelKey, { count: balance })}
    </div>
  );
}
